// src/pages/membres/ModifierMembre.jsx
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Alert, Spinner, Image } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import { COLORS } from '../../constants/colors';

export default function ModifierMembre() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [avatar, setAvatar] = useState(null);
  const [avatarPreview, setAvatarPreview] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    datenaiss: '',
    lieunaiss: '',
    contact: '',
    email: '',
    nb_enf: 0,
    situtaion_maritale: 'Célibataire',
    date_bapt_eau: '',
    date_bapt_saint: '',
    form_seculiere: '',
    form_eccle: '',
    date_consecration: '',
    lieu_affectation: '',
    fonct_org: '',
    date_depart: '',
    role: 'Membre',
    gendre: 'Homme',
    avatar: ''
  });

  const [emailError, setEmailError] = useState('');

  useEffect(() => {
    fetchMembre();
  }, [id]);

  const fetchMembre = async () => {
    try {
      setFetchLoading(true);

      const userStr = localStorage.getItem('user');
      if (!userStr) {
        navigate('/pages/signin2');
        return;
      }

      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;

      const response = await fetch(`https://josephsbusiness.com/api/membre_details.php?user_id=${userId}&id=${id}`, {
        headers: { 'Accept': 'application/json' }
      });

      const result = await response.json();

      if (result.success) {
        const membre = result.membre;

        setFormData({
          nom: membre.nom || '',
          prenom: membre.prenom || '',
          datenaiss: membre.datenaiss || '',
          lieunaiss: membre.lieunaiss || '',
          contact: membre.contact || '',
          email: membre.email || '',
          nb_enf: membre.nb_enf || 0,
          situtaion_maritale: membre.situtaion_maritale || 'Célibataire',
          date_bapt_eau: membre.date_bapt_eau || '',
          date_bapt_saint: membre.date_bapt_saint || '',
          form_seculiere: membre.form_seculiere || '',
          form_eccle: membre.form_eccle || '',
          date_consecration: membre.date_consecration || '',
          lieu_affectation: membre.lieu_affectation || '',
          fonct_org: membre.fonct_org || '',
          date_depart: membre.date_depart || '',
          role: membre.role || 'Membre',
          gendre: membre.gendre || 'Homme',
          avatar: membre.avatar || ''
        });

        if (membre.avatar) {
          setAvatarPreview(`https://josephsbusiness.com/assets/images/${membre.avatar}`);
        }
      } else {
        setError(result.message || 'Erreur de chargement');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setFetchLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'email') {
      setEmailError('');
    }
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.match('image.*')) {
        setError('Veuillez sélectionner une image valide');
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        setError('L\'image ne doit pas dépasser 2MB');
        return;
      }
      setAvatar(file);
      setAvatarPreview(URL.createObjectURL(file));
      setError('');
    }
  };

  const uploadAvatar = async () => {
    if (!avatar) return null;

    const formData = new FormData();
    formData.append('avatar', avatar);
    formData.append('user_id', JSON.parse(localStorage.getItem('user')).id);
    formData.append('membre_id', id);

    const xhr = new XMLHttpRequest();

    return new Promise((resolve, reject) => {
      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable) {
          const progress = Math.round((e.loaded * 100) / e.total);
          setUploadProgress(progress);
        }
      });

      xhr.addEventListener('load', () => {
        if (xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText);
            if (response.success) {
              resolve(response.filename);
            } else {
              reject(new Error(response.message || 'Erreur lors du téléchargement'));
            }
          } catch (e) {
            reject(new Error('Erreur de parsing de la réponse'));
          }
        } else {
          reject(new Error(`Erreur HTTP: ${xhr.status}`));
        }
        setUploadProgress(0);
      });

      xhr.addEventListener('error', () => {
        reject(new Error('Erreur réseau lors du téléchargement'));
        setUploadProgress(0);
      });

      xhr.open('POST', 'https://josephsbusiness.com/api/upload_avatar.php');
      xhr.send(formData);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setEmailError('');
    setUploadProgress(0);

    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        navigate('/pages/signin2');
        return;
      }

      const currentUser = JSON.parse(userStr);
      const userId = currentUser.id || currentUser.id_utilisateur;

      let avatarFilename = formData.avatar;

      if (avatar) {
        try {
          avatarFilename = await uploadAvatar();
        } catch (uploadError) {
          setError('Erreur lors du téléchargement de l\'image: ' + uploadError.message);
          setLoading(false);
          return;
        }
      }

      const dataToSend = {
        nom: formData.nom,
        prenom: formData.prenom,
        datenaiss: formData.datenaiss,
        lieunaiss: formData.lieunaiss,
        contact: formData.contact,
        email: formData.email,
        nb_enf: formData.nb_enf,
        situtaion_maritale: formData.situtaion_maritale,
        date_bapt_eau: formData.date_bapt_eau,
        date_bapt_saint: formData.date_bapt_saint,
        form_seculiere: formData.form_seculiere,
        form_eccle: formData.form_eccle,
        date_consecration: formData.date_consecration,
        lieu_affectation: formData.lieu_affectation,
        fonct_org: formData.fonct_org,
        date_depart: formData.date_depart,
        role: formData.role,
        gendre: formData.gendre,
        avatar: avatarFilename
      };

      const response = await fetch(`https://josephsbusiness.com/api/membres.php?user_id=${userId}&id=${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      });

      const result = await response.json();

      if (result.success) {
        const currentUserId = parseInt(currentUser.id || currentUser.id_utilisateur);
        const memberId = parseInt(id);

        if (currentUserId === memberId) {
          const updatedUser = {
            ...currentUser,
            avatar: avatarFilename
          };
          localStorage.setItem('user', JSON.stringify(updatedUser));
          window.dispatchEvent(new CustomEvent('userUpdated', {
            detail: { avatar: avatarFilename }
          }));
        }

        setSuccess('Membre modifié avec succès');
        setTimeout(() => {
          navigate(`/fidele`);
        }, 2000);
      } else {
        if (result.message && result.message.includes('email')) {
          setEmailError(result.message);
        } else {
          setError(result.message || 'Erreur lors de la modification');
        }
      }
    } catch (err) {
      console.error('❌ Erreur:', err);
      setError(err.message);
    } finally {
      setLoading(false);
      setUploadProgress(0);
    }
  };

  if (fetchLoading) {
    return (
      <>
        <Header />
        <div className="main main-app p-3 p-lg-4" style={{ background: '#f8fafc', minHeight: '100vh' }}>
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
            <div className="text-center">
              <Spinner animation="border" variant="primary" style={{ width: '4rem', height: '4rem' }} />
              <h5 className="fw-bold mt-3" style={{ color: COLORS.primaryDark }}>Chargement du membre</h5>
              <p className="text-muted">Récupération des données en cours...</p>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="main main-app p-3 p-lg-4" style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)' }}>
        <div className="container-fluid px-0 px-lg-3">

          {/* ===== EN‑TÊTE MODERNE ===== */}
          <div className="header-modern mb-4 fade-in">
            <div className="header-left">
              <div className="header-icon-wrapper" style={{ background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.indigo})` }}>
                <i className="ri-user-line"></i>
              </div>
              <div>
                <h5 className="gradient-text">Modifier le profil</h5>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge-modern">
                    <i className="ri-edit-line"></i> {formData.prenom} {formData.nom}
                  </span>
                  <span className="badge-modern" style={{ background: `${COLORS.info}20`, color: COLORS.info }}>
                    <i className="ri-user-line"></i> {formData.role}
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex gap-2 flex-wrap">
              <button className="btn-modern-outline" onClick={() => navigate(-1)}>
                <i className="ri-arrow-left-line"></i> Retour
              </button>
            </div>
          </div>

          {/* ===== MESSAGES ===== */}
          {error && (
            <Alert variant="danger" className="mb-3 fade-in" style={{ borderLeft: `4px solid ${COLORS.danger}` }}>
              <div className="d-flex align-items-center">
                <i className="ri-error-warning-line me-2" style={{ color: COLORS.danger, fontSize: '1.2rem' }}></i>
                <span>{error}</span>
              </div>
            </Alert>
          )}

          {emailError && (
            <Alert variant="danger" className="mb-3 fade-in" style={{ borderLeft: `4px solid ${COLORS.danger}` }}>
              <div className="d-flex align-items-center">
                <i className="ri-mail-close-line me-2" style={{ color: COLORS.danger, fontSize: '1.2rem' }}></i>
                <span>{emailError}</span>
              </div>
            </Alert>
          )}

          {success && (
            <Alert variant="success" className="mb-3 fade-in" style={{ borderLeft: `4px solid ${COLORS.success}` }}>
              <div className="d-flex align-items-center">
                <i className="ri-checkbox-circle-line me-2" style={{ color: COLORS.success, fontSize: '1.2rem' }}></i>
                <span>{success}</span>
              </div>
            </Alert>
          )}

          {/* ===== CARD PRINCIPALE ===== */}
          <Row className="justify-content-center">
            <Col md={10}>
              <Card className="form-card-modern" style={{
                border: 'none',
                borderRadius: '0px',
                background: 'rgba(255,255,255,0.85)',
                backdropFilter: 'blur(12px)',
                boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                overflow: 'hidden'
              }}>
                <Card.Header style={{
                  background: 'rgba(255,255,255,0.5)',
                  borderBottom: '1px solid rgba(0,0,0,0.04)',
                  padding: '0.75rem 1.25rem'
                }}>
                  <h6 className="fw-semibold mb-0" style={{ color: COLORS.primary, fontSize: '0.95rem' }}>
                    <i className="ri-information-line me-2" style={{ color: COLORS.primary }}></i>
                    Informations du membre
                  </h6>
                </Card.Header>
                <Card.Body className="p-4">

                  {/* ===== AVATAR ===== */}
                  <Row className="mb-4">
                    <Col md={12}>
                      <h6 className="fw-semibold mb-3" style={{ color: COLORS.primary, fontSize: '0.9rem' }}>
                        <i className="ri-image-line me-2"></i>
                        Photo de profil
                      </h6>
                    </Col>
                    <Col md={12}>
                      <div className="d-flex align-items-center gap-4">
                        <div className="avatar-preview">
                          {avatarPreview ? (
                            <Image
                              src={avatarPreview}
                              roundedCircle
                              style={{
                                width: '100px',
                                height: '100px',
                                objectFit: 'cover',
                                border: `3px solid ${COLORS.primary}`
                              }}
                            />
                          ) : (
                            <div className="avatar-placeholder" style={{
                              width: '100px',
                              height: '100px',
                              borderRadius: '50%',
                              background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.indigo})`,
                              color: 'white',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '36px',
                              fontWeight: 'bold'
                            }}>
                              {formData.prenom?.charAt(0)}{formData.nom?.charAt(0)}
                            </div>
                          )}
                        </div>
                        <div className="flex-grow-1">
                          <Form.Group controlId="avatar">
                            <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Changer la photo</Form.Label>
                            <Form.Control
                              type="file"
                              accept="image/*"
                              onChange={handleAvatarChange}
                              size="sm"
                              className="form-control-modern"
                              style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                            />
                            <Form.Text className="text-muted small" style={{ fontSize: '0.7rem' }}>
                              Formats acceptés: JPG, PNG, GIF. Taille max: 2MB
                            </Form.Text>
                          </Form.Group>
                          {uploadProgress > 0 && uploadProgress < 100 && (
                            <div className="progress mt-2" style={{ height: '5px', borderRadius: '4px', overflow: 'hidden' }}>
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{
                                  width: `${uploadProgress}%`,
                                  background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.indigo})`
                                }}
                                aria-valuenow={uploadProgress}
                                aria-valuemin="0"
                                aria-valuemax="100"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Form onSubmit={handleSubmit}>
                    <Row className="g-3">

                      {/* ===== IDENTITÉ ===== */}
                      <Col md={12}>
                        <h6 className="fw-semibold mb-2" style={{ color: COLORS.primary, fontSize: '0.85rem' }}>
                          <i className="ri-user-line me-2"></i>
                          Identité
                        </h6>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="nom">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Nom <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="text"
                            name="nom"
                            value={formData.nom}
                            onChange={handleChange}
                            required
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="prenom">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Prénom <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="text"
                            name="prenom"
                            value={formData.prenom}
                            onChange={handleChange}
                            required
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          />
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="gendre">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Genre <span className="text-danger">*</span></Form.Label>
                          <Form.Select
                            name="gendre"
                            value={formData.gendre}
                            onChange={handleChange}
                            required
                            size="sm"
                            className="form-select-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          >
                            <option value="Homme">Homme</option>
                            <option value="Femme">Femme</option>
                            <option value="Enfant">Enfant</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="role">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Rôle <span className="text-danger">*</span></Form.Label>
                          <Form.Select
                            name="role"
                            value={formData.role}
                            onChange={handleChange}
                            required
                            size="sm"
                            className="form-select-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          >
                            <option value="Pasteur">Pasteur</option>
                            <option value="Ancien">Ancien</option>
                            <option value="Diacre">Diacre</option>
                            <option value="Diaconesse">Diaconesse</option>
                            <option value="Jeune">Jeune</option>
                            <option value="Nouveau">Nouveau</option>
                            <option value="Membre">Membre</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="situtaion_maritale">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Situation matrimoniale</Form.Label>
                          <Form.Select
                            name="situtaion_maritale"
                            value={formData.situtaion_maritale}
                            onChange={handleChange}
                            size="sm"
                            className="form-select-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          >
                            <option value="Célibataire">Célibataire</option>
                            <option value="Marié(e)">Marié(e)</option>
                            <option value="Divorcé(e)">Divorcé(e)</option>
                            <option value="Veuf(ve)">Veuf(ve)</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      {/* ===== NAISSANCE ===== */}
                      <Col md={12}>
                        <hr className="my-2" style={{ opacity: 0.2 }} />
                        <h6 className="fw-semibold mb-2 mt-2" style={{ color: COLORS.primary, fontSize: '0.85rem' }}>
                          <i className="ri-cake-line me-2"></i>
                          Naissance
                        </h6>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="datenaiss">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Date de naissance</Form.Label>
                          <Form.Control
                            type="date"
                            name="datenaiss"
                            value={formData.datenaiss}
                            onChange={handleChange}
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="lieunaiss">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Lieu de naissance</Form.Label>
                          <Form.Control
                            type="text"
                            name="lieunaiss"
                            value={formData.lieunaiss}
                            onChange={handleChange}
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="nb_enf">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Nombre d'enfants</Form.Label>
                          <Form.Control
                            type="number"
                            name="nb_enf"
                            value={formData.nb_enf}
                            onChange={handleChange}
                            min="0"
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          />
                        </Form.Group>
                      </Col>

                      {/* ===== CONTACT ===== */}
                      <Col md={12}>
                        <hr className="my-2" style={{ opacity: 0.2 }} />
                        <h6 className="fw-semibold mb-2 mt-2" style={{ color: COLORS.primary, fontSize: '0.85rem' }}>
                          <i className="ri-contacts-line me-2"></i>
                          Contact
                        </h6>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="contact">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Téléphone</Form.Label>
                          <Form.Control
                            type="text"
                            name="contact"
                            value={formData.contact}
                            onChange={handleChange}
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="email">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Email</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            size="sm"
                            className={`form-control-modern ${emailError ? 'is-invalid' : ''}`}
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          />
                          {emailError && (
                            <Form.Text className="text-danger" style={{ fontSize: '0.75rem' }}>{emailError}</Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      {/* ===== VIE SPIRITUELLE ===== */}
                      <Col md={12}>
                        <hr className="my-2" style={{ opacity: 0.2 }} />
                        <h6 className="fw-semibold mb-2 mt-2" style={{ color: COLORS.primary, fontSize: '0.85rem' }}>
                          <i className="ri-heart-line me-2"></i>
                          Vie spirituelle
                        </h6>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="date_bapt_eau">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Date baptême d'eau</Form.Label>
                          <Form.Control
                            type="date"
                            name="date_bapt_eau"
                            value={formData.date_bapt_eau}
                            onChange={handleChange}
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="date_bapt_saint">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Date baptême du Saint-Esprit</Form.Label>
                          <Form.Control
                            type="date"
                            name="date_bapt_saint"
                            value={formData.date_bapt_saint}
                            onChange={handleChange}
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          />
                        </Form.Group>
                      </Col>

                      {/* ===== FORMATION ET CONSÉCRATION ===== */}
                      <Col md={12}>
                        <hr className="my-2" style={{ opacity: 0.2 }} />
                        <h6 className="fw-semibold mb-2 mt-2" style={{ color: COLORS.primary, fontSize: '0.85rem' }}>
                          <i className="ri-graduation-cap-line me-2"></i>
                          Formation et consécration
                        </h6>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="form_seculiere">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Formation séculière</Form.Label>
                          <Form.Control
                            type="text"
                            name="form_seculiere"
                            value={formData.form_seculiere}
                            onChange={handleChange}
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                            placeholder="Diplôme, formation..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="form_eccle">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Formation ecclésiastique</Form.Label>
                          <Form.Control
                            type="text"
                            name="form_eccle"
                            value={formData.form_eccle}
                            onChange={handleChange}
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                            placeholder="Formation biblique..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="date_consecration">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Date de consécration</Form.Label>
                          <Form.Control
                            type="date"
                            name="date_consecration"
                            value={formData.date_consecration}
                            onChange={handleChange}
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="lieu_affectation">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Lieu d'affectation</Form.Label>
                          <Form.Control
                            type="text"
                            name="lieu_affectation"
                            value={formData.lieu_affectation}
                            onChange={handleChange}
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                            placeholder="Lieu d'affectation"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="fonct_org">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Fonction dans l'organisation</Form.Label>
                          <Form.Control
                            type="text"
                            name="fonct_org"
                            value={formData.fonct_org}
                            onChange={handleChange}
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                            placeholder="Fonction"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="date_depart">
                          <Form.Label className="fw-semibold" style={{ fontSize: '0.85rem', color: COLORS.primaryDark }}>Date de départ à la retraite</Form.Label>
                          <Form.Control
                            type="date"
                            name="date_depart"
                            value={formData.date_depart}
                            onChange={handleChange}
                            size="sm"
                            className="form-control-modern"
                            style={{ borderRadius: '4px', border: '1px solid #e2e8f0' }}
                          />
                          <Form.Text className="text-muted small" style={{ fontSize: '0.7rem' }}>
                            À calculer automatiquement (naissance + 70 ans)
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      {/* ===== BOUTONS ===== */}
                      <Col md={12} className="mt-4">
                        <div className="d-flex gap-2 justify-content-end pt-3 border-top" style={{ borderColor: '#e2e8f0 !important' }}>
                          <button
                            className="btn-modern-outline"
                            onClick={() => navigate(`/fidele`)}
                            style={{ fontSize: '0.85rem', padding: '0.4rem 1.2rem' }}
                          >
                            Annuler
                          </button>
                          <button
                            type="submit"
                            className="btn-modern-primary"
                            disabled={loading}
                            style={{
                              fontSize: '0.85rem',
                              padding: '0.4rem 1.8rem',
                              background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.indigo})`,
                              border: 'none',
                              borderRadius: '4px',
                              fontWeight: '500',
                              color: 'white',
                              boxShadow: `0 4px 10px ${COLORS.primary}40`,
                              transition: 'all 0.2s'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.boxShadow = `0 8px 16px ${COLORS.primary}50`;
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = `0 4px 10px ${COLORS.primary}40`;
                            }}
                          >
                            {loading ? (
                              <>
                                <Spinner size="sm" className="me-1" />
                                {uploadProgress > 0 ? `Téléchargement ${uploadProgress}%` : 'Enregistrement...'}
                              </>
                            ) : (
                              'Enregistrer les modifications'
                            )}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Footer />
        </div>
      </div>

      {/* ===== STYLES ===== */}
      <style>{`
        .fade-in {
          animation: fadeIn 0.3s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .header-modern {
          background: white;
          padding: 1.2rem 1.8rem;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
          border-left: 4px solid ${COLORS.secondary};
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
        }
        .header-left {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        .header-icon-wrapper {
          width: 48px;
          height: 48px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.4rem;
        }
        .gradient-text {
          color: #1e293b;
          font-size: 1.3rem;
          font-weight: 700;
          margin: 0;
        }
        .badge-modern {
          background: #f1f4f9;
          color: #475569;
          padding: 0.3rem 0.8rem;
          border-radius: 4px;
          font-size: 0.75rem;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }
        .badge-modern i {
          color: ${COLORS.secondary};
        }
        .btn-modern-outline {
          border: 1px solid #d1d5db;
          background: white;
          padding: 0.4rem 1.2rem;
          border-radius: 4px;
          font-size: 0.85rem;
          font-weight: 500;
          color: #4b5563;
          transition: all 0.2s;
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }
        .btn-modern-outline:hover {
          border-color: ${COLORS.secondary};
          color: ${COLORS.secondary};
          background: #fafafa;
        }
        .btn-modern-primary {
          background: ${COLORS.primary};
          border: none;
          padding: 0.4rem 1.2rem;
          border-radius: 4px;
          font-size: 0.85rem;
          font-weight: 500;
          color: white;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s;
        }
        .btn-modern-primary:hover {
          background: ${COLORS.primaryDark};
          box-shadow: 0 4px 10px rgba(41,90,167,0.3);
        }

        .form-card-modern {
          transition: all 0.3s ease;
        }
        .form-card-modern:hover {
          box-shadow: 0 16px 40px rgba(0,0,0,0.08) !important;
        }

        .form-control-modern:focus,
        .form-select-modern:focus {
          border-color: ${COLORS.primary} !important;
          box-shadow: 0 0 0 3px ${COLORS.primary}20 !important;
        }

        .form-control-modern.is-invalid:focus,
        .form-select-modern.is-invalid:focus {
          box-shadow: 0 0 0 3px ${COLORS.danger}20 !important;
        }

        .avatar-preview {
          transition: transform 0.3s ease;
        }
        .avatar-preview:hover {
          transform: scale(1.05);
        }

        hr {
          opacity: 0.2;
          margin: 0.5rem 0;
        }

        @media (max-width: 768px) {
          .header-modern {
            flex-direction: column;
            align-items: stretch;
            gap: 0.8rem;
            padding: 1rem;
          }
          .header-left {
            flex-wrap: wrap;
          }
        }
      `}</style>
    </>
  );
}